import { Title } from 'components';
import styled from 'styled-components';

export const ReviewTitle = styled(Title)`
  margin-bottom: 14px;
`;
